jQuery.noConflict();
jQuery(document).ready(function($) {
  let marginTop = 30;
  if($('header').length && ($('header').css('position') == 'fixed' || $('header').css('position') == 'sticky')){
    marginTop = $('header').innerHeight() + 10;
    if($('header').css('top')!='auto'){
      marginTop += parseInt($('header').css('top'));
    }
  }
  activeYear(marginTop);

  $(window).scroll(function(){
    activeYear(marginTop);
  });

  $('.previous_auctions_year_selector a').click(function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).data('target')).offset().top - marginTop
    }, 500, function(){
      activeYear(marginTop);
    });
  });

  function activeYear(marginTop){
    let activeElement=0;
    marginTop += 10;
    $('.previous_auctions_year_separator').each(function(){
      if($(this).offset().top - marginTop >= $(window).scrollTop() && activeElement == 0){
        $('.previous_auctions_year_selector a.active').removeClass('active');
        $('.previous_auctions_year_selector a').eq(activeElement).addClass('active');
        return false;
      }
      else if($(this).offset().top - marginTop >= $(window).scrollTop()){
        $('.previous_auctions_year_selector a.active').removeClass('active');
        activeElement--;
        $('.previous_auctions_year_selector a').eq(activeElement).addClass('active');
        return false;
      }
      else if(activeElement == $('.previous_auctions_year_separator').length - 1){
        $('.previous_auctions_year_selector a.active').removeClass('active');
        $('.previous_auctions_year_selector a').last().addClass('active');
        return false;
      }
      activeElement++;
    });
  }

});
